import {
    GET_ROLES_BEGIN,
    GET_ROLES_SUCCES,
    GET_ROLES_FAILURE,
    GET_ACCOUNTS_BEGIN,
    GET_ACCOUNTS_SUCCES,
    GET_ACCOUNTS_FAILURE,
    ROLE_LOGOUT

  } from '../actions/getRolesActions';

  const initialState = {
    roles: [],
    accounts: [],
    loading: false,
    error: null
  };


  export default function getrolereducer(state = initialState, action) {
      //console.log("------- User Reducer -----------");
      //console.log(action.type);
      //console.log(action.payload);
      //console.log("------- User Reducer End-----------");

    switch(action.type) {
      case GET_ROLES_BEGIN:
        return {
          ...state,
          loading: true,
          error: null
        }; 
      case GET_ROLES_SUCCES:
        return {
          ...state,
          roles: action.payload.roledata,
          loading: false,
          error: null
        };

      case GET_ROLES_FAILURE:
            return {
              ...state,
              loading: false,
              error: action.payload.error
            };

      /*------------------------------------*/      
       case GET_ACCOUNTS_BEGIN:
            return {
              ...state,
              loading: true,
              error: null
            }; 
      
      case GET_ACCOUNTS_SUCCES:
             return {
              ...state,
              accounts: action.payload.accountsdata.data,
              loading: false,
              error: null
            };
      
      case GET_ACCOUNTS_FAILURE:
               return {
                ...state,
                loading: false,
                error: action.payload.error
              };

      case ROLE_LOGOUT:
              return {
                ...state,
                roles: [],
                accounts: [],
                loading: false,
                error: null
               };

              

        default:
        return state;
    }
    
  }